"use strict";
var editor_2d = require("editor-2d");
var lib_core = require("lib-core");
var editor_2d = require("editor-2d");
var HandleView = editor_2d.HandleView;
var drawTextDataTo2D = editor_2d.drawTextDataTo2D;

var PropertyInteractionView = function (gui, interactionModel, parentGroup, layers) {
    editor_2d.TextInteractionView.call(this, gui, interactionModel, parentGroup, layers);
};
lib_core.mixin(PropertyInteractionView, editor_2d.DrawingElement);
lib_core.inherit(PropertyInteractionView, editor_2d.TextInteractionView);

module.exports = PropertyInteractionView;

PropertyInteractionView.prototype.draw = function () {
    var self = this;

    $(this.elementSvgGroup).empty();
    $(this.controlGroup).empty();

    if(!this.data.isAlive()) return;

    // draw visible
    drawTextDataTo2D(this.gui.svg, this.elementSvgGroup, this.data, this.interactionModel.mirrored(), true);

    // draw control
    drawTextDataTo2D(this.gui.svg, this.controlGroup, this.data, this.interactionModel.mirrored(), true);
    this.control = $(":nth-last-child(1)", this.controlGroup);
    this.resizeControl();
};